import { IconButton } from '@material-tailwind/react';
import Icons from 'src/components/atoms/icons/icons';
import { buildWhatsAppClickToChatUrl } from 'src/modules/shared/utils/formatting/whatsapp.util';

interface WhatsappButtonProps {
  phone: string;
  name?: string;
  company?: string;
  customMessage?: string;
}

const WhatsappButton: React.FC<WhatsappButtonProps> = ({
  phone,
  name,
  company,
  customMessage,
}) => {
  let message = '';
  if (customMessage) message = customMessage;
  // TODO: check when implementing i18n
  else if (name && company) message = `Hola, soy ${name} de ${company}`;

  const url = buildWhatsAppClickToChatUrl({ phone, message });

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block mx-1"
    >
      <IconButton variant="text" className="w-7 h-7">
        <Icons.Whatsapp />
      </IconButton>
    </a>
  );
};

export default WhatsappButton;
